export const EVENT_SOURCES = {
    LEARNING: 'Learning',
    ASSESMENT: 'Assesment',
    SYSTEM: 'System',
    TASK_EVALUATION: 'TaskEvaluation',
};

export const EVENT_TYPES = {
    ASSIGNED: 'Assigned',
    COMPLETED: 'Completed',
    PASSED: 'Passed',
    FAILED: 'Failed',
    REMINDER: 'Reminder',
    ABORTED: 'Aborted',
    OVERDUE: 'Overdue',
    FINAL_REMINDER: 'FinalReminder',
    INFO: 'Info',
    SECURITY: 'Security',
    MAINTENANCE: 'Maintenance',
    TASK_CLOSED: 'TaskClosed',
    TASK_REDO: 'TaskRedo',
    TASK_EXEMPTED: 'TaskExempted',
    TASK_RECALLED_BY_ASSESSEE: 'TaskRecalledByAssessee',
    TASK_RECEIVED_FOR_EVALUATION: 'TaskReceivedForEvaluation',
    TASK_RECEIVED_FOR_EXEMPTION: 'TaskReceivedForExemption',
    TASK_EXEMPTION_REJECTED: 'TaskExemptionRejected',
    TASK_ASSESSOR_CHANGED: 'TaskAssessorChanged',
    TASK_RECALLED_ASSESSOR_SIGN_OFF: 'TaskRecalledAssessorSignOff',
    TASK_RECALLED_CREW_SIGN_OFF: 'TaskRecalledCrewSignOff',
    TASK_RECALLED_ELEMENT_UPDATED: 'TaskRecalledElementUpdated',
    TASK_RECALLED_ELEMENT_DELETED: 'TaskRecalledElementDeleted',
    TASK_RECALLED_ASSESSOR_UNAVAILABLE: 'TaskRecalledAssessorUnavailable',
    LEARNING_REASSIGNED_CATEGORY_CHANGED: 'LearningReassignedCategoryChanged',
    PASSWORD_CHANGED: 'PasswordChanged',
    ADMIN_COMPLETED_SUBMITTED_REQUEST: 'AdminCompletedSubmittedRequest',
};
